import { createBox } from '@shopify/restyle';

import { Theme } from '@themes/theme';
import { getStructuralRowBackground } from '@utils/hoverStyles';

const Box = createBox<Theme>();

type WebHoverBoxProps = React.ComponentProps<typeof Box> & {
  children?: React.ReactNode;
  isHovered?: boolean;
  isPressing?: boolean;
  isSelected?: boolean;
  alphabetize?: boolean;
  alphabetical?: boolean;
  isProject?: boolean;
  noItemSeparatorComponent?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};
export const BoxHover: React.FC<WebHoverBoxProps> = ({
  children,
  paddingHorizontal,
  isHovered,
  isPressing,
  isSelected,
  alphabetize,
  alphabetical,
  isProject,
  noItemSeparatorComponent,
  onMouseEnter,
  onMouseLeave,
}) => {
  // Structural-row rule (TA-9005): hover → grey01, pressing/selected → greenSecondaryMild.
  const bg = getStructuralRowBackground(
    !!isHovered,
    !!isPressing || !!isSelected
  );
  return (
    <>
      <Box
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        backgroundColor={bg}
        flexDirection='row'
        justifyContent='space-between'
        alignItems='center'
        paddingHorizontal={paddingHorizontal}
        paddingVertical={isProject ? undefined : 'xs'}
        borderColor='greenSecondary'
        borderTopWidth={isPressing ? 1 : 0}
        borderBottomWidth={isPressing ? 1 : 0}>
        {children}
      </Box>
      {!noItemSeparatorComponent && (
        <Box
          height={isPressing ? 0 : 1}
          backgroundColor='grey02'
          marginHorizontal={!alphabetize && !alphabetical ? undefined : 'm'}
        />
      )}
    </>
  );
};
